module.exports = __webpack_public_path__ + "static/media/1_pl.3e4d9ae3.png";